/**
 * Utility functions for formatting visibility values
 */

/**
 * Format visibility values as '10 km' if >= 10000, otherwise '1,200 m'
 * @param value - Visibility value in meters (can be null/undefined)
 * @returns Formatted visibility string, or 'No Data' if value is invalid
 */
export function formatVisibility(value: number | null | undefined): string {
  if (value === null || value === undefined || isNaN(value)) {
    return 'No Data';
  }
  if (Math.abs(value) >= 10000) {
    return `${Math.round(value / 1000)} km`;
  }
  return `${Math.round(value)} m`;
}
